/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SpecialityModel } from '../../models/speciality-model';

export interface AdminFhirIdSpecialitiesLanguageRegionGet$Params {
  fhirId: string;
  languageRegion: string;
}

export function adminFhirIdSpecialitiesLanguageRegionGet(http: HttpClient, rootUrl: string, params: AdminFhirIdSpecialitiesLanguageRegionGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<SpecialityModel>>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdSpecialitiesLanguageRegionGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
    rb.path('languageRegion', params.languageRegion, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<SpecialityModel>>;
    })
  );
}

adminFhirIdSpecialitiesLanguageRegionGet.PATH = '/Admin/{fhirId}/Specialities/{languageRegion}';
